import { type UseFormInput, useForm } from "@mantine/form"
import { useEffect, useRef } from "react"

interface IProps<Data> extends UseFormInput<Partial<Data>> {
  data: Data
  dependencies?: any[]
  initialValues?: Partial<Data>
  transformInitialValues?: (data: Data) => Partial<Data>
}

export function useFormData<Data>({
  data,
  dependencies,
  initialValues,
  transformInitialValues = (data) => data as any,
  ...props
}: IProps<Data>) {
  const form = useForm({
    validateInputOnBlur: true,
    validateInputOnChange: true,
    initialValues: initialValues ?? ((data && transformInitialValues?.(data)) || {}),
    ...props,
  })

  const hasDataLoadedRef = useRef(false)

  useEffect(() => {
    if (!data) return
    if (hasDataLoadedRef.current) return

    const values = transformInitialValues(data)
    form.setInitialValues(values)
    form.setValues(values as any)
    form.resetDirty()
    form.resetTouched()
    hasDataLoadedRef.current = true
  }, dependencies ?? [data])

  return form
}
